import { TOptions } from "i18next";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { InternalLabelData } from "../../../models/InternalLabelData";
import ModalConfirm from "../../ModalConfirm";

import "./styles.scss";

interface InternalLabelEditModalProps {
  label: InternalLabelData | null;
  onClose: () => void;
  onSave: (label: Partial<InternalLabelData>) => void;
  onDelete?: (labelId: number) => void;
}

const InternalLabelEditModal: React.FC<InternalLabelEditModalProps> = ({
  label,
  onClose,
  onSave,
  onDelete,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string, options?: TOptions) =>
    _t(`internalLabelsManagementPage.InternalLabelEditModal.${key}`, options);
  const [name, setName] = useState(label?.name || "");
  const [description, setDescription] = useState(label?.description || "");
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  return (
    <>
      <div className="modal modal-default">
        <div className="modal-mains modal-edit-label">
          <button className="btn-close" onClick={onClose}></button>
          <div className="top-title">
            {label ? t("edit_label") : t("add_label")}
          </div>
          <div className="form-group">
            <label>{t("name")}</label>
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>{t("description")}</label>
            <input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="bottom-btns">
            <button className="btn btn-border" onClick={onClose}>
              {t("cancel")}
            </button>
            {label && onDelete && (
              <button
                className="btn btn-red"
                onClick={() => setShowConfirmModal(true)}
              >
                {t("delete_label")}
              </button>
            )}
            <button
              className="btn btn-blue"
              onClick={() => onSave({ id: label?.id, name, description })}
            >
              {t("save")}
            </button>
          </div>
        </div>
      </div>
      {showConfirmModal && label && onDelete && (
        <ModalConfirm
          title={"please_confirm"}
          description={"please_confirm_to_delete_the_internal_label"}
          cancelLabel={"cancel"}
          confirmLabel={"confirm"}
          onClose={() => setShowConfirmModal(false)}
          onConfirm={() => {
            setShowConfirmModal(false);
            onDelete(Number(label.id));
          }}
          color="red"
        >
          <div style={{ textAlign: "center", margin: "12px 0" }}>
            {label.name}
          </div>
        </ModalConfirm>
      )}
    </>
  );
};

export default InternalLabelEditModal;
